'use client';

import { Skeleton, TableFooter } from '@lulalife/design-system';

type ResultCountFooterProps = {
  /** The list's total from the API (`meta.total`), not the rows loaded so far. */
  total: number | undefined;
  /** The count is not known yet (first page in flight): a count skeleton stands in. A caller whose load failed passes
   * `total` as undefined and `loading` false, so nothing is drawn. */
  loading?: boolean;
  'data-testid'?: string;
};

/**
 * The "N results" line under a Settings table (Figma's table footer), over DS `TableFooter`.
 * Pass it as `ListingTable`'s `footer`. Draws nothing for an empty list; while the count is
 * unknown it shows the footer with a count skeleton so the frame does not jump. The DS footer's
 * own `loading` flag draws nothing, so the skeleton is passed in as its content.
 */
export const ResultCountFooter = ({
  total,
  loading = false,
  'data-testid': testId,
}: ResultCountFooterProps) => {
  if (!loading && !(total && total > 0)) return null;
  return (
    <TableFooter data-testid={testId}>
      {loading ? (
        <Skeleton width={72} height={12} rounded="sm" />
      ) : (
        `${total} ${total === 1 ? 'result' : 'results'}`
      )}
    </TableFooter>
  );
};

export default ResultCountFooter;
